import React, { useState } from 'react';
import {
  Card,
  TextField,
  Text,
  BlockStack,
} from '@shopify/polaris';
import { authService } from '../services/authService';
import logoDark from '../assets/LogoDark.svg';

const LoginPage = ({ onLoginSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      await authService.login(email, password);
      onLoginSuccess();
    } catch (error) {
      // Handle the specific error response structure
      if (error.error) {
        setError(error.error);
      } else if (error.message) {
        setError(error.message);
      } else {
        setError('Login failed. Please check your credentials.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{ maxWidth: '400px', width: '100%' }}>
        <Card>
          <div style={{ padding: '32px' }}>
            <BlockStack gap="6">
              {/* Logo */}
              <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                <img 
                  src={logoDark} 
                  alt="Snaps Logo" 
                  style={{ 
                    height: '90px',
                    width: 'auto'
                  }} 
                />
                <Text variant="headingLg" as="h1" alignment="center">
                  Welcome Back
                </Text>
                <Text variant="bodyMd" as="p" alignment="center" tone="subdued">
                  Sign in to Snaps Dashboard
                </Text>
              </div>

              {/* Error Banner */}
              {error && (
                <div style={{
                  backgroundColor: '#d82c0d',
                  borderRadius: '8px',
                  padding: '8px',
                  marginBottom: '16px',
                  border: '1px solid #b91c1c'
                }}>
                  <div style={{ fontWeight: 'bold'}}>
                    <p style={{ 
                      margin: 0, 
                      color: '#FFFFFF', 
                      fontSize: '14px', 
                      fontWeight: 'bold', 
                      textAlign: 'center'
                    }}>
                      {error}
                    </p>
                  </div>
                </div>
              )}

              {/* Login Form */}
              <form onSubmit={handleSubmit}>
                <BlockStack gap="4">
                  <TextField
                    label="Email"
                    type="email"
                    value={email}
                    onChange={setEmail}
                    autoComplete="email"
                    required
                    disabled={isLoading}
                  />
                  
                  <TextField
                    label="Password"
                    type="password"
                    value={password}
                    onChange={setPassword}
                    autoComplete="current-password"
                    required
                    disabled={isLoading}
                  />

                  <button
                    type="submit"
                    disabled={!email || !password || isLoading}
                    style={{
                      width: '100%',
                      padding: '8px',
                      backgroundColor: '#846dec',
                      borderRadius: '8px',
                      color: '#FFFFFF',
                      fontSize: '16px',
                      fontWeight: '600',
                      marginTop: '30px',
                      cursor: isLoading || !email || !password ? 'not-allowed' : 'pointer',
                      opacity: isLoading || !email || !password ? 0.6 : 1,
                      transition: 'all 0.2s ease'
                    }}
                  >
                    {isLoading ? 'Signing in...' : 'Sign In'}
                  </button>
                </BlockStack>
              </form>

            </BlockStack>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default LoginPage; 